export const TIME_BUCKET_OPTIONS = [
  { value: 'WEEK', label: 'Por semana' },
  { value: 'MONTH', label: 'Por mês' },
  { value: 'QUARTER', label: 'Por trimestre' },
];

export const DEFAULT_TIME_BUCKET = 'MONTH';

export const getTimeBucketLabel = (bucket) =>
  TIME_BUCKET_OPTIONS.find((o) => o.value === bucket)?.label ?? 'Por período';
